import { FaPen, FaTrash } from "react-icons/fa";
import {
  Container,
  ContainerEditar,
  ContainerExplicacao,
  ContainerHeader,
  DadosContainer,
  Title,
  TituloEditar,
} from "./style";
import { PrimaryButton } from "components/Button/style";
import { Col } from "react-bootstrap";
import { IDadosCriarLote } from "../../../../interfaces/IDadosCriarLote";

interface IProps {
  onClickRemover: () => void;
  onClickAcaoVeiculo: () => void;
  resumo: IDadosCriarLote;
  onClickEditar: () => void;
  desabilitarRemover: boolean;
}
export function ResumoCriarLote({
  onClickRemover,
  resumo,
  onClickAcaoVeiculo,
  onClickEditar,
  desabilitarRemover,
}: IProps) {
  return (
    <Container>
      <ContainerHeader>
        <Title>
          {resumo.tipo === "bloquear" ? "Bloquear" : "Desbloquear"} veículos
        </Title>

        <div style={{ display: "flex", gap: 8 }}>
          <PrimaryButton
            buttonWidth="xl"
            buttonWidthTipo="px"
            onClick={() => {
              window.location.href = "/app/veiculo/bloqueio";
            }}
            outline
            variante="primary"
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton
            buttonWidth="xl"
            buttonWidthTipo="px"
            onClick={onClickRemover}
            outline
            variante="primary"
            disabled={desabilitarRemover}
          >
            <FaTrash />
            Remover do lote
          </PrimaryButton>
          <PrimaryButton
            buttonWidth="xl"
            buttonWidthTipo="px"
            onClick={onClickAcaoVeiculo}
            variante="primary"
            title="Salvar lote"
          >
            {resumo.tipo === "bloquear" ? "Bloquear" : "Desbloquear"} veículo
          </PrimaryButton>
        </div>
      </ContainerHeader>
      <ContainerExplicacao>
        Confira as informações abaixo para confirmar o{" "}
        {resumo.tipo === "bloquear" ? "bloqueio" : "desbloqueio"} dos veículos
      </ContainerExplicacao>
      <ContainerEditar>
        <TituloEditar>Dados do lote</TituloEditar>
        <div>
          <span onClick={onClickEditar} style={{ cursor: "pointer" }}>
            <FaPen style={{ marginRight: 8 }} />
            Editar
          </span>
        </div>
      </ContainerEditar>
      <DadosContainer>
        <Col>
          <div>Empresa</div>
          <div>
            <strong>{resumo.nomeEmpresa ? resumo.nomeEmpresa : "--"}</strong>
          </div>
        </Col>
        <Col>
          <div>Divisão</div>
          <div>
            <strong>{resumo.nomeDivisao ? resumo.nomeDivisao : "--"}</strong>
          </div>
        </Col>
        <Col>
          <div>Centro de Custo</div>
          <div>
            <strong>
              {resumo.nomeCentroCusto ? resumo.nomeCentroCusto : "--"}
            </strong>
          </div>
        </Col>
        <Col>
          <div>Solicitante</div>
          <div>
            <strong>
              {resumo.nomeSolicitante ? resumo.nomeSolicitante : "--"}
            </strong>
          </div>
        </Col>
        <Col>
          <div>CNPJ</div>
          <div>
            <strong>{resumo.cnpj ? resumo.cnpj : "--"}</strong>
          </div>
        </Col>
      </DadosContainer>
    </Container>
  );
}
